export default "__VITE_ASSET__COZg7rxv__"